import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoLv: CultureInfo = {
  name: 'lv',
  displayName: 'Latvian',
  iso3LanguageCode: 'lav',
  iso2LanguageCode: 'lv',
  ietfLanguageTag: 'lv',
  parent: null
};
